import { Component, OnInit } from '@angular/core';
import { fadeInOut } from '../../shared/helpers/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanyContactService } from '../../shared/services/index';
import { ToastrService } from 'ngx-toastr';
import { INavdlContact } from '../../shared/models/navdl-contact';
import { NavDLService } from '../../shared/services/navdl.service';

@Component({
    selector: 'app-navigator',
    templateUrl: './navigator.component.html',
    styleUrls: ['./navigator.component.scss'],
    animations: [fadeInOut],
    standalone: false
})
export class NavigatorComponent implements OnInit {
  contactForm: FormGroup;
  countryLOV: String[];
  ddwFields: Object = { text: 'label', value: 'label' };
  ddwHeight = '220px';
  countryWaterMark: String = 'Select Country';
  loading = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private contactService: CompanyContactService,
    private navDLService: NavDLService,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', Validators.required],
      jobTitle: ['', Validators.required],
      companyName: ['', Validators.required],
      country: ['', Validators.required],
      medicalDevice: [false],
      pharmaceutical: [false],
      consumerOtc: [false],
      cosmetics: [false],
      demo: [null],
      comments: [''],
    });
    this.getCountries();
  }

  onSubmit() {
    this.loading = true;
    if (this.contactForm.valid) {
      const atLeastOneChecked = this.contactForm.get('medicalDevice')?.value
        || this.contactForm.get('pharmaceutical')?.value
        || this.contactForm.get('consumerOtc')?.value
        || this.contactForm.get('cosmetics')?.value;

      if (!atLeastOneChecked) {
        this.loading = false;
        this.toastr.error('Please select an industry');
        return;
      }
      this.navDLService.sendNavDLContactMessage(this.contactForm.value).subscribe({
        next: () => {
          this.loading = false;
          this.toastr.success('Message submitted successfully');
          this.contactForm.reset();
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
        },
      });
    } else {
      this.loading = false;
      this.toastr.error('Please complete all required fields');
    }
  }

  getCountries(): void {
    this.contactService.getCountries().subscribe(
      (data) => {
        if (data) {
          this.countryLOV = data['countryList'];
        }
      },
      (error) => {
        this.toastr.error(
          error && error.errorMessage ? error.errorMessage : error,
        );
      },
    );
  }
}
